/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import parse from "html-react-parser";

class Messages extends Component {
  state = {};
  componentDidMount = () => {
    this.scrollDown();
  };
  componentDidUpdate = (newProps) => {
    this.scrollDown();
  };

  scrollDown = () => {
    const { container } = this.refs;
    container.scrollTop = container.scrollHeight;
  };

  render() {
    const { messages, user } = this.props.childProps;
    //console.log(messages)
    //console.log(user)
    return (
      <Fragment>
        <div className="chatting_group" ref={"container"}>
          <div className="chatting_padding">
            {messages.map((mes, i) => {
              //console.log(mes)
              return (
                <div
                  key={mes.id}
                  className={`chatting_div${
                    mes.gubun === "emoticon"
                      ? "3"
                      : mes.sender === user.name
                      ? "2"
                      : "1"
                  }`}
                >
                  <dl>
                    {mes.sender === user.name ? (
                      <dt>{mes.time}</dt>
                    ) : (
                      <dt>
                        <img src={mes.icon} />
                        <span>{mes.sender}</span> {mes.time}
                      </dt>
                    )}

                    <dd>
                      <div className="message">
                        {parse(mes.message.replace(/<[^>]+>/g, ""))}
                      </div>
                    </dd>
                  </dl>
                  {/*
                                    <div className='time'>{mes.time}</div>
                                    <div className='data'>
                                        <div className='message' dangerouslySetInnerHTML={{__html: mes.message}}>
                                            
                                        </div>
                                        <div className='name'>
                                            {mes.sender}
                                        </div>    
                                    </div>
                                    */}
                </div>
              );
            })}

            {/*
                        <div className="chatting_div1">
                            <dl>
                                <dt>
                                    <img src="img/test_img9.png"/>
                                    <span>이갑열</span> 오전 11:35
                                </dt>
                                <dd>
                                    하이방가방가~~<br/>
                                    방가워요
                                </dd>
                            </dl>
                        </div>
                        <div className="line_text"><div>2020년 6월 13일 목요일</div></div>
                        <div className="chatting_div2">
                            <dl>
                                <dt>오전 11:35</dt>
                                <dd>
                                    하이방가방가~~<br/>
                                    방가워요
                                </dd>
                            </dl>
                        </div>
                        <div className="chatting_div3">
                            <dl>
                                <dt>오전 11:35</dt>
                                <dd><img src="img/live_img/img_test50.png"/></dd>
                            </dl>
                        </div>
                        */}
          </div>
        </div>
        {/*
                <div 
                    ref={'container'}
                    className='thread-container'
                >
                    <div className='thread'>
                        {
                            messages.map((mes, i) => {
                                return (
                                    <div
                                        key={mes.id}
                                        className={`message-container ${mes.sender === user.name && 'right'}`}
                                    >
                                        <div className='time'>{mes.time}</div>
                                        <div className='data'>
                                            <div className='message' dangerouslySetInnerHTML={{__html: mes.message}}>
                                                
                                            </div>
                                            <div className='name'>
                                                {mes.sender}
                                            </div>    
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {
                            typingUsers.map((name) => {
                                return (
                                    <div key={name} className="typing-user">
                                        {`${name} is typing...`}
                                    </div>
                                )

                            })
                        }
                    </div>

                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Messages));
